export default __webpack_public_path__ + "static/media/image.express-418-private-limited.b5d93201.png";